import { CSSProperties } from 'react';

import { M100RichTextLayout } from '~/lib/data-contract';

import { useRawHtml } from './hooks/useRawHtml';

export type RichTextProps = {
	className?: string;
	maxWidth?: CSSProperties['maxWidth'];
};
export type RawHtmlProps = RichTextProps & {
	html?: string;
	layout?: M100RichTextLayout;
};

export const RawHtml = ({ html = '', ...rest }: RawHtmlProps) => {
	return useRawHtml(html, rest);
};
